<template>
    <v-container fluid class="mr-10">
        <v-row>
            <p class="text-h4">Pedido realizado!</p>
            <order :order="order" ></order>            
        </v-row>
        <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="8">
            <p> 
                <v-btn dark class="text-center" :to="'/store'">
                    Voltar para loja 
                </v-btn>

                <v-btn dark class="text-center" :to="'/'">
                    Acessar fichas
                </v-btn>
            </p>
            </v-col>
            <v-col cols="2"></v-col>
        </v-row>
    </v-container>
</template>

<script>
    import order from '../components/cart/Order';
    export default {
        components:{
            'order' : order
        },
        computed: {
            order () { 
                return this.$store.getters.order;
            },
            orderProducts (){
                return this.$store.getters.order.products;
            }
        }
    }
</script>
